import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import axios from "../../utilities/axios";
import { deliveryEstimate } from "../../utilities/deliveryEstimate";
import * as API_END_POINT from "../../utilities/constant";
import logoPng from '../../assets/images/logo-png.png';
import { Info } from "lucide-react";

const Skeleton = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`}></div>
);

const OrderDetails = (props) => {
  const { id, showRetailerOrderDetail = false, setorderInfo, index } = props;
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          API_END_POINT.STORE_ORDER_DETAILS(id),
          {}
        );
      
        if (response && response.data && response.data.data) {
          setorderInfo({
            retailer_order_id: response.data.data[0].retailer_order_id,
            created_at: response.data.data[0].created_at
          })
          setOrderDetails(response.data.data[0]);
        } else {
          throw new Error("No data received from the server");
        }
      } catch (err) {
        setError(
          err.message || "An error occurred while fetching the order details"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [id]);

  const formatDate = (date) => moment(date).format("MM/DD/YYYY");
  const twoDecimal = (num) => parseFloat(num).toFixed(2);
  const toFourDigit = (number) => number.toString().padStart(4, "0");
  const EllipsisText = (text, maxLength) => {
    // Determine if the text needs to be truncated
    const shouldTruncate = text.length > maxLength;
    const displayText = shouldTruncate
      ? text.slice(0, maxLength) + "..."
      : text;

    return displayText;
  };
  const OrderSkeleton = () => (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <Skeleton className="h-8 w-1/4 mb-6" />

      <div className="grid grid-cols-3 gap-4 mb-6">
        {[...Array(3)].map((_, index) => (
          <div key={index}>
            <Skeleton className="h-4 w-1/2 mb-2" />
            <Skeleton className="h-6 w-3/4" />
          </div>
        ))}
      </div>

      {[...Array(2)].map((_, index) => (
        <div key={index} className="border rounded-lg p-4 mb-6">
          <div className="grid grid-cols-5 gap-4 mb-4">
            {[...Array(5)].map((_, i) => (
              <div key={i}>
                <Skeleton className="h-4 w-3/4 mb-2" />
                <Skeleton className="h-6 w-1/2" />
              </div>
            ))}
          </div>

          <div className="bg-gray-100 p-4 rounded-lg flex items-start space-x-4 mb-4">
            <Skeleton className="w-12 h-12 rounded" />
            <div className="flex-grow">
              <Skeleton className="h-6 w-3/4 mb-2" />
              <Skeleton className="h-4 w-1/2" />
            </div>
            <Skeleton className="h-6 w-20" />
          </div>

          <Skeleton className="h-4 w-full" />
        </div>
      ))}
    </div>
  );

  if (loading) {
    return <OrderSkeleton />;
  }

  if (error) {
    return <div className="text-center text-red-600 p-4">{error}</div>;
  }

  if (!orderDetails) {
    return <div className="text-center p-4">No order details found.</div>;
  }

  const isOnlyAlphabetNoSpace = (str) => /^[A-Za-z]+$/.test(str);

  return (
    <>
      {orderDetails.order_brands?.map((brand, index) => (

        <div key={index} className="">
          <span className="hidden md:block">
            Fullfilled By {EllipsisText(brand?.store_name, 20)}
          </span>
          <div className="border-[0px] md:border rounded-lg p-[0px] md:p-4 mb-6 mt-[14px]">
            {brand.order_brand_items.map((item, i) => (
              <>
              <p className={`text-[#2C2F32] text-[14px] font-bold p-2 md:p-4 leading-[22px] space-x-4 mb-2 ${isOnlyAlphabetNoSpace(brand?.brand_user?.is_multi_brand ? item?.shopdot_vendor_display_name :'')?'block overflow-hidden whitespace-nowrap text-ellipsis' : 'line-clamp-2'}`}>{brand?.brand_user?.is_multi_brand ? item?.shopdot_vendor_display_name :''}</p>
              <div key={i} className="p-2 md:p-4 rounded-lg border-[#E5E7E8] flex items-start space-x-4 mb-4">
                  <div className="relative border border-[#E5E7E8] w-16">
                    <img
                      src={
                        item.variant_image || item.products.product_images.find(image => image.is_main === '1')?.src || item?.products?.product_images?.[0]?.src || logoPng
                      }
                      alt={item.product_title}
                      className="w-full rounded-md aspect-square object-contain"
                    />
                  </div>
                <div className='flex items-start justify-between flex-wrap w-full'>
                  <div className="flex-grow">
                      <h3 className="font-semibold text-lg">
                        <div className="tooltip-container-table">
                          <div className="tooltip-text-table fw500">{item.product_title}</div>
                          <span className="ellipsis-text fw500 max-w-[172px] md:max-w-[300px]">{item.product_title}</span>
                        </div>
                      </h3>

                    <p className="text-sm text-gray-600">
                      {item?.variant_title !== "Default Title" && (
                        <div className="quintity">
                          <span className="quintity-value text-[#657075] text-[12px]">
                            ({item?.variant_title})
                          </span>
                        </div>
                      )}
                    </p>
                    <p className="text-sm text-gray-600">
                      <div><span className='text-[12px] font-normal text-primary-text'>X </span><span className='text-[16px] font-normal text-primary-text'>{item.quantity}</span></div>
                    </p>
                    {item?.customizable_note && (
                      <p className="text-sm text-gray-600">
                        Customized Tag Name:{" "}
                        <span className="note">{item?.customizable_note}</span>
                      </p>
                    )}
                  </div>
                  <div className="text-right">
                    {brand?.discount_prcnt ? (
                      <div className="price strike-price">
                        <s>${twoDecimal(item?.msrp_per_item)}</s>{" "}
                        <span className="discount-price text-primary-text font-semibold">
                          $
                          {twoDecimal(
                            item?.msrp_per_item -
                            item?.msrp_per_item * (brand?.discount_prcnt / 100)
                          )}
                        </span>
                      </div>
                    ) : (
                      <div className="price text-primary-text font-semibold">
                        $
                        {twoDecimal(
                          item?.msrp_per_item -
                          item?.msrp_per_item * (brand?.discount_prcnt / 100)
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
                {index !== brand.order_brand_items.length - 1 && <hr />}</>
            ))}
            <hr />
            <div className="hidden md:flex flex-col space-y-3 py-4 pb-0">
              <div> </div>
              <div className="flex justify-between">
                <p className="text-[18px] text-primary-text mb-1">Subtotal <span className="text-secondary-text text-[14px] font-normal">({brand.order_brand_items.length} item{brand.order_brand_items.length > 1 ? 's' : ''})</span></p>
                <p className="">
                  ${twoDecimal(brand.msrp_sub_total)}
                </p>
              </div>
              {brand?.discount_sub_total ? (
                <div className="flex justify-between">
                  <p className="text-[18px] text-primary-text mb-1">Customer Discount</p>
                  <p className="font-semibold">
                    ${twoDecimal(brand.discount_sub_total)}
                  </p>
                </div>
              ) : null}
              <div className="flex justify-between">
                <p className="text-[18px] text-primary-text mb-1">Shipping</p>
                {twoDecimal(brand.shipping_cost_sub_total) > 0 ?
                  <p>${twoDecimal(brand.shipping_cost_sub_total)}</p> : <p className='text-[#3C704B]'>Free</p>}
              </div>
              <hr />

              <div className="flex justify-between text-[24px] text-primary-text font-medium">
                <p className=" mb-1">Total</p>
                <p className="">
                  $
                  {twoDecimal(
                    brand.order_sub_total - (brand.discount_sub_total || 0)
                  )}
                </p>

              </div>
              {deliveryEstimate(brand?.brand_user?.shipping_address) && (
                <p className="text-[12px] font-normal text-primary-text mb-1">{deliveryEstimate(brand?.brand_user?.shipping_address)}</p>
              )}
            </div>
          </div>

        </div>
      ))}</>
  );
};

export default OrderDetails;
